import { render, staticRenderFns } from "./collectShareArea.vue?vue&type=template&id=01838122&scoped=true&"
import script from "./collectShareArea.vue?vue&type=script&lang=js&"
export * from "./collectShareArea.vue?vue&type=script&lang=js&"
import style0 from "./collectShareArea.vue?vue&type=style&index=0&id=01838122&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01838122",
  null
  
)

export default component.exports